var themeLoader = {};

themeLoader.load = function(init) {

  var body = document.getElementsByTagName('body')[0];

  // Class-preserving theme stamp (2026-09): the old wholesale
  // `body.className = 'theme_X'` REPLACED the whole class string, wiping any
  // other class on <body> — it deleted staffMode (staffModeEarly.js) on every
  // load for users with selectedTheme set, so the staff nav swapped in after
  // paint. Filter out only the old theme_* token and keep everything else.
  function stampBodyTheme(themeId) {
    var cls = body.className.split(/\s+/).filter(function (c) {
      return c && c.indexOf('theme_') !== 0;
    });
    cls.push('theme_' + themeId);
    body.className = cls.join(' ');
  }

  // (Original read: className.indexOf('theme_')===0 → remember that theme as
  // defaultTheme. Now token-based so other classes on <body> don't break it.)
  var existingTheme = body.className.split(/\s+/).filter(function (c) {
    return c.indexOf('theme_') === 0;
  })[0];
  if (existingTheme && init) {
    localStorage.defaultTheme = existingTheme.substring(6);
  } else {
    delete localStorage.defaultTheme;
  }

  if (init && !localStorage.selectedTheme && !localStorage.manualDefault) {
    return;
  }

  // Theme wrappers are dual-scoped ("html.theme_X, .theme_X") since the FOUC fix:
  // the inline head script stamps <html> at page load only. A runtime switch must
  // re-stamp <html> too, or the previous theme's html.* rules keep matching and win
  // cascade ties until reload ("some elements don't change" bug). Also clear the
  // head script's inline background so the new theme's CSS governs <html>
  // (inline styles beat every stylesheet rule).
  var html = document.documentElement;

  if (localStorage.selectedTheme) {
    if (themeLoader.customCss && themeLoader.customCss.parentNode) {
      themeLoader.customCss.remove();
    }
    stampBodyTheme(localStorage.selectedTheme);
    html.className = 'theme_' + localStorage.selectedTheme;
  } else {
    if (themeLoader.customCss && !themeLoader.customCss.parentNode) {
      document.head.appendChild(themeLoader.customCss);
    }
    // "Default" = the engine's baked defaultTheme. It is gitgud — the SAME fallback
    // the FOUC inline script in base.njk uses (`selectedTheme || 'gitgud'`). Do NOT
    // read localStorage.defaultTheme here: that key actually holds whatever theme was
    // ACTIVE at last load ("lastActiveTheme"), so restoring from it re-applied the
    // current non-default theme on a "Default" selection and only fixed itself on
    // reload. Hardcoding the real default makes a runtime switch to Default identical
    // to a fresh page load in every case.
    var def = 'gitgud';
    stampBodyTheme(def);
    html.className = 'theme_' + def;
  }

  if (!init) {
    html.style.removeProperty('background');
  }

};

var linkedCss = document.getElementsByTagName('link');

for (var i = 0; i < linkedCss.length; i++) {

  var ending = '/custom.css';

  if (linkedCss[i].href.indexOf(ending) === linkedCss[i].href.length
      - ending.length) {
    themeLoader.customCss = linkedCss[i];
    break;
  }
}

themeLoader.load(true);
